import React, { useEffect, useMemo, useState } from 'react';
import useWordle from '../hooks/useWordle';
import Modal from './Modal';
import Grid from './Grid';

type Props = {
  solution: string;
} & ReturnType<typeof useWordle>;

const Wordle: React.FC<Props> = ({
  solution,
  currentGuess,
  guesses,
  handleKeyup,
  isCorrect,
  turn,
}) => {
  const [showModal, setShowModal] = useState<boolean>(false);

  const nbLetters = useMemo<number>(() => {
    return solution.length;
  }, [solution.length]);

  useEffect(() => {
    window.addEventListener('keyup', handleKeyup);

    if (isCorrect) {
      setTimeout(() => setShowModal(true), 2000);
      window.removeEventListener('keyup', handleKeyup);
    }

    if (turn > 5) {
      setTimeout(() => setShowModal(true), 2000);
      window.removeEventListener('keyup', handleKeyup);
    }

    return () => window.removeEventListener('keyup', handleKeyup);
  }, [handleKeyup, isCorrect, turn]);

  return (
    <div>
      <Grid
        currentGuess={currentGuess}
        guesses={guesses}
        turn={turn}
        nbLetters={nbLetters}
      />
      {showModal && (
        <Modal isCorrect={isCorrect} turn={turn} solution={solution} />
      )}
    </div>
  );
};

export default Wordle;
